<template>
	<div class="cs-timepicker">
		<Dropdown
			:buttonclass="'btn-light'"
			v-model="real_value"
			:items="items"
		></Dropdown>
	</div>
</template>

<script>
import formatter 		from '@/store/orm/helpers/formater';
export default {
	name: 'Timepicker',
	// @todo this.seperator mit dem formatter ablösen
	computed:{
		items(){
			var items = [],

				mintime = this.mintime.split(this.separator),
				maxtime = this.maxtime.split(this.separator);

			for (let h = 0; h < 24; h += 1) {
				if(h >= mintime[0] && h <= maxtime[0]) {

					for (let m = 0; m < 60; m += (h == maxtime[0] && m > maxtime[1] ? 60 : this.minuteInterval)) {
		        		items.push({
		        			value: this.formater(h, m),
		        			label: this.formater(h, m, this.separator),
		        		});

		        	}

	        	}

        	}

			return items;
		}
	},

	data() {
		return {
			real_value: false,
		};
	},

	watch: {
		// @todo time[1] - (time[1] % 30) muss eig so schlau sein, das es nicht abrundet, sonder aufrunde (und dann halt auch auf die richtige stunde)
		value(value) {
			if(value){
				var time = value.split(this.separator);
				if(time){
					this.real_value = this.formater(time[0], time[1] - (time[1] % 30));
				}
			}

		},
		real_value(newValue, oldValue) {
			if(newValue != oldValue){
				this.$emit('input', newValue);
				this.$emit('change', newValue);
			}
		}
	},

	props: {
		separator: {
			default: ':'
		},

		format: {
			default: 'HH:MM'
		},

		minuteInterval: {
			default: 30
		},

		mintime: {
			default: '8:30'
		},

		maxtime: {
			default: '20:30'
		},

		value: {
			default(){
				return new Date();
			}
		},
	},

	mounted(){
		if(this.value){
			var time = this.value.split(this.separator);
			this.real_value = formater(time[0], time[1] - (time[1] % 30));
		}
	},

	methods: {
		formater(hour, min, separator){
			if(typeof separator !== 'string') separator = this.separator;

			var out = hour + "" + separator;
			if((typeof min === 'string' && min.length < 2) || (typeof min === 'number' && min < 10)) {

				out += "0"
			}
			out += (min || min === 0 ? min : '');
			return out;
		},
		disabledDate (time) {
			return false;
        },
	}
}
</script>

<style lang="scss">
@import '../../styles/config';

.cs-timepicker {
	.dropdown-menu {
		max-height: 10em;
		overflow-y: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Forms/Timepicker.vue